import * as Sentry from '@sentry/react';
import { environment } from '../environment';
import { REPLAY_BLOCK_SELECTORS } from './replayPrivacy';

export function initMonitoring() {
  if (!environment.production) return;

  Sentry.init({
    dsn: environment.sentryDsn,
    // Error-only replay still records into a live rolling buffer, so the block list matters — see `replayPrivacy.ts`.
    integrations: [Sentry.replayIntegration({ block: REPLAY_BLOCK_SELECTORS })],
    tracesSampleRate: 0,
    tracePropagationTargets: [],
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 1.0,
    environment: environment.sentryEnvironment,
    release: environment.appVersion,
    sendDefaultPii: true,
    beforeSend: (event) => {
      // Drop errors that originate FROM scripts injected by wallet browser extensions
      // or mobile in-app browsers. Only check the top frame (throw site) — Sentry
      // orders frames bottom-to-top. If our code crashes while called by injected code,
      // the top frame is ours and we still see the error.
      const frames = event.exception?.values?.[0]?.stacktrace?.frames;
      const topFrame = frames?.[frames.length - 1];
      const topFn = topFrame?.function || '';
      const topFile = topFrame?.filename || '';

      if (
        topFn.includes('handleWalletConnect') ||
        topFn.includes('ReactNativeHistoryShim') ||
        topFile.includes('ReactNativeHistoryShim') ||
        topFn.includes('__rabby') ||
        topFn.includes('webkit.messageHandlers')
      ) {
        return null;
      }

      return event;
    },
  });

  try {
    if (window.xBrowserSessionId) {
      Sentry.setTag('x-browser-session-id', window.xBrowserSessionId);
    }
  } catch (e) {}
}
